import { partnerIds } from '@/modules/partner/partnerConfig'
import { useParams } from 'react-router-dom'

export const useFunnelSource = (overriddenCategoryId?: string) => {
  const { partnerId, categoryId } = useParams()

  const finalCategoryId = overriddenCategoryId ?? categoryId

  if (!partnerId && !finalCategoryId) {
    return null
  }

  if (partnerId === partnerIds.qonto && finalCategoryId) {
    return `Qonto - ${categoryId}`
  }

  if (partnerId === partnerIds.qonto) {
    return 'Qonto'
  }

  if (finalCategoryId) {
    return `SSF - ${finalCategoryId}`
  }

  return null
}
